import {
  MemberClassNamesTerms,
  MembersNthTerms,
  TeamMembersFormat as TeamMembersFormatI,
} from '../models/common';

export const validateEmail = (email: string): boolean => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return true;
  } else {
    return false;
  }
};

const findNthTerm = (first: number, second: number, num: number) => {
  const diff = second - first;
  const fact = (num - 1) * diff;
  const term = first + fact;
  return term;
};

export const getMembersNthTerms = (
  data: TeamMembersFormatI[]
): MembersNthTerms => {
  const nthTerms: number[] = [];
  const mobileNthTerms: number[] = [];
  const firstChildNthTerms: number[] = [];
  const thirdChildNthTerms: number[] = [];
  const members = data?.filter((entry) => entry.type === 'blockTeamMember');
  members?.forEach((member, id) => {
    nthTerms.push(findNthTerm(4, 10, id + 1));
    mobileNthTerms.push(findNthTerm(2, 8, id + 1));
    firstChildNthTerms.push(findNthTerm(7, 13, id + 1));
    thirdChildNthTerms.push(findNthTerm(3, 9, id + 1));
  });

  return {
    nthTerms,
    mobileNthTerms,
    firstChildNthTerms,
    thirdChildNthTerms,
  };
};

export const getMemberClassNames = (
  member: TeamMembersFormatI,
  membersNthTerms: MembersNthTerms,
  styles: {
    readonly [key: string]: string;
  }
): MemberClassNamesTerms => {
  const nthClass =
    member.index &&
    membersNthTerms?.nthTerms.find((value) => value === member.index)
      ? styles.teamMemberMarginLeft
      : '';

  const evenClass =
    (member.index || 1) % 2 === 0
      ? styles.teamMemberEven
      : styles.teamMemberOdd;

  const firstChildClass = membersNthTerms?.firstChildNthTerms.find(
    (value) => value === member.index
  )
    ? styles.firstChild
    : '';
  const thirdChildNthClass = membersNthTerms?.thirdChildNthTerms.find(
    (value) => value === member.index
  )
    ? styles.teamMemberOdd
    : '';

  const mobileNthClass = membersNthTerms?.mobileNthTerms.find(
    (value) => value === member.index
  )
    ? styles.teamMemberMobileMarginTop
    : '';

  return {
    nthClass,
    evenClass,
    firstChildClass,
    thirdChildNthClass,
    mobileNthClass,
  };
};

export const shuffleArray = (array?: TeamMembersFormatI[]) => {
  if (!array) return;
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

const createRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * max) + min;
};

export const createArrayWithRandomValues = (
  arrayLength: number,
  min: number,
  max: number
) => {
  const array: number[] = [];
  for (let i = 0; i < arrayLength; i++) {
    if (array[i - 1] > 0) array.push(createRandomNumber(min, 0));
    else array.push(createRandomNumber(0, max));
  }
  return array;
};
